import {
  Box,
  Typography,
} from '@mui/material';
import { T, Icon, stitchPill, stitchCard } from './stitch';
import { formatDate } from './projectMeta';


// Callsheet Card
function CallsheetCard({ callsheet }) {
  const title = callsheet.fields?.Titel || 'Callsheet';
  const datum = callsheet.fields?.['Datum (handmatig)'] || callsheet.fields?.['StartDatum (from DraaidagenOutlook)']?.[0];
  const adres = callsheet.fields?.Adres || '';
  const statusPdf = callsheet.fields?.['Status PDF'] || '';
  // Use the lookup field for contact person name
  const contactPersonRaw = callsheet.fields?.['Naam (from Contactpersoon Settelefoon)'] || [];
  const contactPerson = Array.isArray(contactPersonRaw) ? contactPersonRaw.join(', ') : contactPersonRaw;

  return (
    <Box
      sx={{
        p: 2.5,
        ...stitchCard,
        borderLeft: `4px solid ${T.emerald}`,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="subtitle2" sx={{ fontFamily: T.font, fontWeight: 600 }}>{title}</Typography>
          {datum && (
            <Typography variant="body2" sx={{ fontFamily: T.fontBody, color: T.outline, mt: 0.5 }}>
              {formatDate(datum)}
            </Typography>
          )}
        </Box>
        {statusPdf && (
          <Typography component="span" sx={stitchPill(
            statusPdf.includes('gereed') ? '#166534' : '#92400e',
            statusPdf.includes('gereed') ? '#dcfce7' : T.amberBg
          )}>
            {statusPdf}
          </Typography>
        )}
      </Box>

      {adres && (
        <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline, mt: 1, display: 'block' }}>
          {'\u{1F4CD}'} {adres}
        </Typography>
      )}

      {contactPerson && (
        <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline, mt: 0.5, display: 'block' }}>
          <Icon name="person" size={12} sx={{ verticalAlign: 'middle', marginRight: 2 }} /> {contactPerson}
        </Typography>
      )}
    </Box>
  );
}

export default CallsheetCard;
